export const Prices = [
  {
    _id: 0,
    nameKey: "under_100",
    array: [0, 10],
  },
  {
    _id: 1,
    nameKey: "from_100_to_300",
    array: [100, 300],
  },
  {
    _id: 2,
    nameKey: "from_300_to_600",
    array: [300, 600],
  },
  {
    _id: 3,
    nameKey: "from_600_to_900",
    array: [600, 900],
  },
  {
    _id: 4,
    nameKey: "from_900_to_1000",
    array: [900, 1000],
  },
  {
    _id: 5,
    nameKey: "over_1000",
    array: [1000, 99999],
  },
];
